<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               :title="this.type" size="30%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               append-to-body ="ture"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData" v-if="this.type==='审核'">
          <el-form-item label="审核金额" >
            <el-input type="text" autocomplete="off" style="width: 9vw" v-model="formData.checkAmount" clearable
                      />
          </el-form-item>
          <el-form-item label="审核附件" >
            <text-upload :photo-url.sync="checkFile" />
          </el-form-item>
          <el-form-item label="审核说明" >
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" autocomplete="off"
                      v-model="formData.checkNote" clearable />
          </el-form-item>
        </el-form>
        <span v-else>确认{{this.type}}【{{this.confirmNo}}】吗？</span>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="rejectSaleReward" v-if="type == '审核'">
           驳回
          </el-button>
          <el-button type="primary" @click="closeSaleReward">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

<!--    &lt;!&ndash; 关闭弹窗 &ndash;&gt;-->
<!--    <orderPop v-if="showOrderPop"-->
<!--              :visiable.sync="showOrderPop"-->
<!--              multi="false"-->
<!--              @commit="orderCommit"-->
<!--              :siteId="formData.siteId"/>-->
  </div>
</template>
<script>
// import orderPop from './orderDialog.vue'

import api from "@/api/projectApi";
import textUpload from "@/components/formItem/textUpload.vue";
import request from "@/router/axios";

export default {
  components: {textUpload},
  inject: ['reload'],
  name: 'edit',
  props: ['multi','dataId','type', 'confirmNo'],
  created() {
    console.log("获取id:",this.dataId);
    this.formData.id = this.dataId
    this.formData.statName = this.type
  },
  data() {
    return {
      formData: {
        remark: null,
        id: null,
        statName: null,
      },
      showOrderPop: false,

      drawer: true,
      checkFile: [],

    }
  },
  methods: {

    closeSaleReward() {

      if (this.type == '审核' ) {
        if (!this.formData.checkAmount){
          this.$message.warning('请填写审核金额')
          return
        }
        if (!this.formData.checkNote){
          this.$message.warning('请填写审核说明')
          return
        }
        console.log("this.checkFile-------------",this.checkFile)
        if (this.checkFile){

          this.formData.checkFile = this.checkFile[0].url
        }
      }

        let url = "";

        if (this.formData.statName == '提交') {
          url = api.wkSaleRewardApply.submitUrl;
        } else if (this.formData.statName == '审核') {
          url = api.wkSaleRewardApply.checkUrl;
        }

        this.dealSaleReward(this.type,url)

    },
    rejectSaleReward(){
      this.dealSaleReward('驳回',api.wkSaleRewardApply.rejectUrl)
    },

    dealSaleReward(type,url){
      this.$baseConfirm('您确定要'+type+'吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: url,
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$mask.close()
          this.$message.success('操作成功')
          this.$emit('closeD')
          this.$emit('flushed')
          this.reload()
        })
      })
    },

    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('closeD', false)
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
